"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const facility_service_1 = require("../../../../services/facility.service");
const facility_dto_1 = require("../../../../dtos/facility-dto");
const funding_service_1 = require("../../../../../residents/services/funding.service");
require("../../../../../residents/dtos/anacc-fixed-component-dto");
require("../../../../dtos/region-dto");
const _ = require("underscore");
const dnaRSnackBar_service_1 = require("../../../../../common/dna-r/dnaRSnackBar.service");
require("@angular/material/chips");
const keycodes_1 = require("@angular/cdk/keycodes");
const dialog_1 = require("@angular/material/dialog");
const value_with_effective_date_component_1 = require("../../../value-with-effective-date/value-with-effective-date.component");
const i0 = require("@angular/core");
const i1 = require("../../../../services/facility.service");
const i2 = require("../../../../../residents/services/funding.service");
const i3 = require("../../../../../common/dna-r/dnaRSnackBar.service");
const i4 = require("@angular/material/dialog");
const i5 = require("@angular/forms");
const i6 = require("@angular/common");
const i7 = require("@angular/material/chips");
const i8 = require("@angular/material/tooltip");
const i9 = require("../../../../../common/directives/dnaR-popover/dnaR-popover.directive");
const i10 = require("@angular/material/icon");
function FacilityDetailsEditTabComponent_label_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 48);
    i0.ɵɵtext(1, "Aged care service name");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_label_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 48);
    i0.ɵɵtext(1, "Facility name");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵtext(1, " Aged care service name required ");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_13_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtext(1, " Facility name required ");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FacilityDetailsEditTabComponent_div_13_div_1_Template, 2, 0, "div", 49);
    i0.ɵɵtemplate(2, FacilityDetailsEditTabComponent_div_13_div_2_Template, 2, 0, "div", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(12);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (_r3 == null ? null : _r3.errors == null ? null : _r3.errors.required) && ctx_r4.facility.facilityType === "AgeCare");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (_r3 == null ? null : _r3.errors == null ? null : _r3.errors.required) && ctx_r4.facility.facilityType === "IndependentLiving");
} }
function FacilityDetailsEditTabComponent_div_14_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 81);
    i0.ɵɵtext(1, " NAPS ID required ");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵtext(1, " Only numbers are allowed ");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FacilityDetailsEditTabComponent_div_14_div_10_div_1_Template, 2, 0, "div", 79);
    i0.ɵɵtemplate(2, FacilityDetailsEditTabComponent_div_14_div_10_div_2_Template, 2, 0, "div", 80);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r11 == null ? null : _r11.errors == null ? null : _r11.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r11 == null ? null : _r11.errors == null ? null : _r11.errors.pattern);
} }
function FacilityDetailsEditTabComponent_div_14_div_19_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵtext(1, " EDI minor ID required ");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_div_19_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 86);
    i0.ɵɵtext(1, " EDI minor ID must follow the patten AAA99999 ");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FacilityDetailsEditTabComponent_div_14_div_19_div_1_Template, 2, 0, "div", 83);
    i0.ɵɵtemplate(2, FacilityDetailsEditTabComponent_div_14_div_19_div_2_Template, 2, 0, "div", 84);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r13 = i0.ɵɵreference(18);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r13 == null ? null : _r13.errors == null ? null : _r13.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r13 == null ? null : _r13.errors == null ? null : _r13.errors.pattern);
} }
function FacilityDetailsEditTabComponent_div_14_div_27_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵtext(1, " Region required ");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_div_27_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FacilityDetailsEditTabComponent_div_14_div_27_div_9_div_1_Template, 2, 0, "div", 90);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r31 = i0.ɵɵreference(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r31 == null ? null : _r31.errors == null ? null : _r31.errors.required);
} }
function FacilityDetailsEditTabComponent_div_14_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelement(2, "i", 7);
    i0.ɵɵelementStart(3, "label", 87);
    i0.ɵɵtext(4, "Region");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵelementStart(6, "select", 88, 89);
    i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_div_14_div_27_Template_select_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.facility.regionId = $event; });
    i0.ɵɵelement(8, "option", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, FacilityDetailsEditTabComponent_div_14_div_27_div_9_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r31 = i0.ɵɵreference(7);
    const ctx_r16 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngModel", ctx_r16.facility.regionId);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", _r0.submitted || (_r31 == null ? null : _r31.touched));
} }
function FacilityDetailsEditTabComponent_div_14_ng_template_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "h3", 93);
    i0.ɵɵtext(2, "Modified Monash Model (MMM)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 94);
    i0.ɵɵtext(4, "The Modified Monash Model (MMM) of remoteness is used to calculate the fixed funding component; Base Care Tariff (BCT)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_option_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 95);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const anaccFixedComponent_r36 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("value", anaccFixedComponent_r36.facilityMMMClassification);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", anaccFixedComponent_r36.facilityMMMClassificationText, " ");
} }
function FacilityDetailsEditTabComponent_div_14_div_53_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵtext(1, " MMM facility classification required ");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_div_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FacilityDetailsEditTabComponent_div_14_div_53_div_1_Template, 2, 0, "div", 96);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r19 = i0.ɵɵreference(49);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r19 == null ? null : _r19.errors == null ? null : _r19.errors.required);
} }
function FacilityDetailsEditTabComponent_div_14_span_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 98);
    i0.ɵɵtext(1, "To find your MMM category, type your facility's address into the ");
    i0.ɵɵelementStart(2, "a", 99);
    i0.ɵɵtext(3, "Health Workforce Locator");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " tool and check the 2019 checkbox.");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_span_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 98);
    i0.ɵɵtext(1, "Classification retrieved from Services Australia.");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_span_67_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 100);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("From ", i0.ɵɵpipeBind2(2, 1, ctx_r24.supportedResidentsThresholdEffectiveDate, "dd MMM yyyy"), "");
} }
function FacilityDetailsEditTabComponent_div_14_span_77_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 100);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("From ", i0.ɵɵpipeBind2(2, 1, ctx_r25.registeredBedsEffectiveDate, "dd MMM yyyy"), "");
} }
function FacilityDetailsEditTabComponent_div_14_div_78_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 92);
    i0.ɵɵelementStart(1, "div", 94);
    i0.ɵɵtext(2, "Value must align to the Department of Health published matrix");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FacilityDetailsEditTabComponent_div_14_div_78_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 101);
    i0.ɵɵtext(3, "Care minutes supplement");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "a", 102);
    i0.ɵɵtemplate(5, FacilityDetailsEditTabComponent_div_14_div_78_ng_template_5_Template, 3, 0, "ng-template", null, 103, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 9);
    i0.ɵɵelementStart(8, "span", 104);
    i0.ɵɵelementStart(9, "input", 105, 106);
    i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_div_14_div_78_Template_input_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r42); const ctx_r41 = i0.ɵɵnextContext(2); return ctx_r41.facility.careMinutesSupplement = $event; })("keydown", function FacilityDetailsEditTabComponent_div_14_div_78_Template_input_keydown_9_listener($event) { i0.ɵɵrestoreView(_r42); return $event.key === "-" || $event.key === "e" ? $event.preventDefault() : null; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r38 = i0.ɵɵreference(6);
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("dnaRPopover", _r38);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r26.facility.careMinutesSupplement);
} }
function FacilityDetailsEditTabComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementStart(4, "label", 53);
    i0.ɵɵtext(5, "NAPS ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "a", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 9);
    i0.ɵɵelementStart(8, "input", 55, 56);
    i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_div_14_Template_input_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.facility.napsId = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, FacilityDetailsEditTabComponent_div_14_div_10_Template, 3, 2, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 5);
    i0.ɵɵelementStart(12, "div", 6);
    i0.ɵɵelement(13, "i", 7);
    i0.ɵɵelementStart(14, "label", 57);
    i0.ɵɵtext(15, "EDI minor ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 9);
    i0.ɵɵelementStart(17, "input", 58, 59);
    i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_div_14_Template_input_ngModelChange_17_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r46 = i0.ɵɵnextContext(); return ctx_r46.facility.ediMinorCustomerID = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, FacilityDetailsEditTabComponent_div_14_div_19_Template, 3, 2, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 5);
    i0.ɵɵelementStart(21, "div", 6);
    i0.ɵɵelementStart(22, "label", 60);
    i0.ɵɵtext(23, "ARCH ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 9);
    i0.ɵɵelementStart(25, "input", 61, 62);
    i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_div_14_Template_input_ngModelChange_25_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r47 = i0.ɵɵnextContext(); return ctx_r47.facility.archId = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, FacilityDetailsEditTabComponent_div_14_div_27_Template, 10, 2, "div", 63);
    i0.ɵɵelementStart(28, "div", 5);
    i0.ɵɵelementStart(29, "div", 6);
    i0.ɵɵelementStart(30, "h3", 20);
    i0.ɵɵtext(31, "Funding details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div", 5);
    i0.ɵɵelementStart(33, "div", 6);
    i0.ɵɵelementStart(34, "label", 64);
    i0.ɵɵtext(35, "Significantly refurbished or newly built");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 9);
    i0.ɵɵelementStart(37, "input", 65);
    i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_div_14_Template_input_ngModelChange_37_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r48 = i0.ɵɵnextContext(); return ctx_r48.facility.significantlyRefurbishedDateUtc = $event; });
    i0.ɵɵpipe(38, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 5);
    i0.ɵɵelementStart(40, "div", 6);
    i0.ɵɵelement(41, "i", 7);
    i0.ɵɵelementStart(42, "label", 66);
    i0.ɵɵtext(43, "MMM facility classification");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(44, "a", 67);
    i0.ɵɵtemplate(45, FacilityDetailsEditTabComponent_div_14_ng_template_45_Template, 5, 0, "ng-template", null, 68, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "div", 9);
    i0.ɵɵelementStart(48, "select", 69, 70);
    i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_div_14_Template_select_ngModelChange_48_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r49 = i0.ɵɵnextContext(); return ctx_r49.facility.facilityMMMClassification = $event; });
    i0.ɵɵelementStart(50, "option", 31);
    i0.ɵɵtext(51, "Select classification");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(52, FacilityDetailsEditTabComponent_div_14_option_52_Template, 2, 2, "option", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(53, FacilityDetailsEditTabComponent_div_14_div_53_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "div", 5);
    i0.ɵɵelementStart(55, "div", 72);
    i0.ɵɵtemplate(56, FacilityDetailsEditTabComponent_div_14_span_56_Template, 5, 0, "span", 73);
    i0.ɵɵtemplate(57, FacilityDetailsEditTabComponent_div_14_span_57_Template, 2, 0, "span", 73);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(58, "div", 5);
    i0.ɵɵelementStart(59, "div", 6);
    i0.ɵɵelement(60, "i", 7);
    i0.ɵɵelementStart(61, "label");
    i0.ɵɵtext(62, "Supported resident threshold");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(63, "div", 74);
    i0.ɵɵelementStart(64, "a", 75);
    i0.ɵɵlistener("click", function FacilityDetailsEditTabComponent_div_14_Template_a_click_64_listener() { i0.ɵɵrestoreView(_r45); const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.openSupportedResidentsThresholdListMaintenanceDialog(); });
    i0.ɵɵtext(65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(66, "div", 76);
    i0.ɵɵtemplate(67, FacilityDetailsEditTabComponent_div_14_span_67_Template, 3, 4, "span", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(68, "div", 5);
    i0.ɵɵelementStart(69, "div", 78);
    i0.ɵɵelement(70, "i", 7);
    i0.ɵɵelementStart(71, "label");
    i0.ɵɵtext(72, "Registered beds");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(73, "div", 74);
    i0.ɵɵelementStart(74, "a", 75);
    i0.ɵɵlistener("click", function FacilityDetailsEditTabComponent_div_14_Template_a_click_74_listener() { i0.ɵɵrestoreView(_r45); const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.openRegisteredBedsListMaintenanceDialog(); });
    i0.ɵɵtext(75);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(76, "div", 76);
    i0.ɵɵtemplate(77, FacilityDetailsEditTabComponent_div_14_span_77_Template, 3, 4, "span", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(78, FacilityDetailsEditTabComponent_div_14_div_78_Template, 11, 2, "div", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(9);
    const _r13 = i0.ɵɵreference(18);
    const _r17 = i0.ɵɵreference(46);
    const _r19 = i0.ɵɵreference(49);
    const ctx_r5 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(2);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("matTooltipPosition", "after");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r5.facility.napsId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r0.submitted || (_r11 == null ? null : _r11.touched));
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngModel", ctx_r5.facility.ediMinorCustomerID);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r0.submitted || (_r13 == null ? null : _r13.touched));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngModel", ctx_r5.facility.archId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.regions.length);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngModel", i0.ɵɵpipeBind2(38, 20, ctx_r5.facility.significantlyRefurbishedDateUtc, "yyyy-MM-dd"));
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("dnaRPopover", _r17);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r5.facility.facilityMMMClassificationIsActual)("ngModel", ctx_r5.facility.facilityMMMClassification);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r5.anaccFixedComponents);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r0.submitted || (_r19 == null ? null : _r19.touched));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r5.facility.facilityMMMClassificationIsActual);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.facility.facilityMMMClassificationIsActual);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1("", ctx_r5.supportedResidentsThreshold, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.supportedResidentsThresholdEffectiveDate);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r5.registeredBeds);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.registeredBedsEffectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.facility.facilityMMMClassification === "StandardMMM1");
} }
function FacilityDetailsEditTabComponent_div_15_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 100);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("From ", i0.ɵɵpipeBind2(2, 1, ctx_r52.numberOfUnitsEffectiveDate, "dd MMM yyyy"), "");
} }
function FacilityDetailsEditTabComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelementStart(2, "div", 78);
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementStart(4, "label");
    i0.ɵɵtext(5, "Number of units");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 74);
    i0.ɵɵelementStart(7, "a", 75);
    i0.ɵɵlistener("click", function FacilityDetailsEditTabComponent_div_15_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(); return ctx_r53.openNumberOfUnitsListMaintenanceDialog(); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 76);
    i0.ɵɵtemplate(10, FacilityDetailsEditTabComponent_div_15_span_10_Template, 3, 4, "span", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r6.numberOfUnits);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.numberOfUnitsEffectiveDate);
} }
function FacilityDetailsEditTabComponent_mat_chip_25_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 109);
} }
function FacilityDetailsEditTabComponent_mat_chip_25_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 107);
    i0.ɵɵlistener("removed", function FacilityDetailsEditTabComponent_mat_chip_25_Template_mat_chip_removed_0_listener() { i0.ɵɵrestoreView(_r58); const facilityLocation_r55 = ctx.$implicit; const ctx_r57 = i0.ɵɵnextContext(); return ctx_r57.removeLocation(facilityLocation_r55); });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, FacilityDetailsEditTabComponent_mat_chip_25_mat_icon_2_Template, 1, 0, "mat-icon", 108);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const facilityLocation_r55 = ctx.$implicit;
    i0.ɵɵproperty("selectable", true)("removable", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", facilityLocation_r55.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !facilityLocation_r55.accommodations);
} }
/**
 * Displays the facility details edit tab.
 */
class FacilityDetailsEditTabComponent {
    /**
     * Initializes a new instance of the FacilityDetailsTabComponent class.
     *
     * @param facilityService The facility service.
     * @param fundingService The funding service.
     * @param snackBarService The SnackBar service.
     * @param dialog The material design dialog.
     */
    constructor(facilityService, fundingService, snackBarService, dialog) {
        this.facilityService = facilityService;
        this.fundingService = fundingService;
        this.snackBarService = snackBarService;
        this.dialog = dialog;
        /**
         * New location chips seperator key codes.
         */
        this.separatorKeysCodes = [keycodes_1.ENTER, keycodes_1.COMMA];
        /**
         * Event emitted when the user finishes editting.
         */
        this.onDone = new core_1.EventEmitter();
        /**
         * Saves the facility.
         *
         * @param isValid Is the HTML form current valid.
         */
        this.saveFacility = function (isValid) {
            if (isValid) {
                this.facilityService.saveFacility(this.facility)
                    .then(result => {
                    this.snackBarService.success("Facility saved");
                    this.doneEditting(false);
                }, () => {
                    this.snackBarService.failure("Unexpected error while saving the facility");
                });
            }
        };
        this.anaccFixedComponents = [];
        this.regions = [];
    }
    set facility(value) {
        this._facility = value;
        this.resetRegistredBeds();
        this.resetSupportedResidentsThreshold();
        this.resetNumberOfUnits();
    }
    get facility() {
        return this._facility;
    }
    /**
     * @inheritdoc
     */
    ngOnInit() {
        this.fundingService.getAnaccFixedComponents().then(result => {
            this.anaccFixedComponents = result;
        }, () => {
            this.snackBarService.failure("Unexpected error while loading MMM classifications");
        });
        this.facilityService.getRegions().then(result => {
            this.regions = result;
        }, () => {
            this.snackBarService.failure("Unexpected error while loading regions");
        });
    }
    /**
     * Open the Supported Resident Threshold list maintenance dialog.
     */
    openSupportedResidentsThresholdListMaintenanceDialog() {
        const dialogConfig = new dialog_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
            title: 'Supported resident threshold',
            itemLabel: 'threshold',
            valueType: value_with_effective_date_component_1.ValueWithEffectiveDateDialogComponentValueType.Percentage,
            valuesWithEffectiveDates: this.facility.supportedResidentsThresholdList
        };
        const dialogRef = this.dialog.open(value_with_effective_date_component_1.ValueWithEffectiveDateDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
            if (!result.cancelled) {
                this.facility.supportedResidentsThresholdList = _.sortBy(result.data, 'startDate').reverse();
                this.resetSupportedResidentsThreshold();
            }
        });
    }
    /**
     * Open the Registered Beds list maintenance dialog.
     */
    openRegisteredBedsListMaintenanceDialog() {
        const dialogConfig = new dialog_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
            title: 'Registered beds',
            itemLabel: 'bed amount',
            valueType: value_with_effective_date_component_1.ValueWithEffectiveDateDialogComponentValueType.Integer,
            valuesWithEffectiveDates: this.facility.registeredBedsList
        };
        const dialogRef = this.dialog.open(value_with_effective_date_component_1.ValueWithEffectiveDateDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
            if (!result.cancelled) {
                this.facility.registeredBedsList = _.sortBy(result.data, 'startDate').reverse();
                this.resetRegistredBeds();
            }
        });
    }
    /**
     * Open the Number of Units list maintenance dialog.
     */
    openNumberOfUnitsListMaintenanceDialog() {
        const dialogConfig = new dialog_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
            title: 'Number of units',
            itemLabel: 'unit amount',
            valueType: value_with_effective_date_component_1.ValueWithEffectiveDateDialogComponentValueType.Integer,
            valuesWithEffectiveDates: this.facility.numberOfUnitsList
        };
        const dialogRef = this.dialog.open(value_with_effective_date_component_1.ValueWithEffectiveDateDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
            if (!result.cancelled) {
                this.facility.numberOfUnitsList = _.sortBy(result.data, 'startDate').reverse();
                this.resetNumberOfUnits();
            }
        });
    }
    /**
     * Add a new locations to the facility in response to a @see MatChipInputEvent.
     *
     * @param event The @see MatChipInputEvent event.
     */
    addLocations(event) {
        const input = event.input;
        const value = event.value;
        // Add location
        if ((value || '').trim()) {
            const newLocation = new facility_dto_1.FacilityLocationDto();
            newLocation.id = -1;
            newLocation.name = value.trim();
            this.facility.locations.push(newLocation);
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }
    /**
     * Remove the provided location from the facility.
     *
     * @param location The location to remove.
     */
    removeLocation(location) {
        const index = this.facility.locations.indexOf(location);
        if (index >= 0) {
            this.facility.locations.splice(index, 1);
        }
    }
    /**
     * Emits the @see onDone event.
     *
     * @param cancelled true if the user cancelled editting, otherwise false.
     */
    doneEditting(cancelled) {
        this.onDone.emit(cancelled);
    }
    resetRegistredBeds() {
        if (this.facility && this.facility.registeredBedsList && this.facility.registeredBedsList.length > 0) {
            this.registeredBeds = Number.parseInt(this.facility.registeredBedsList[0].value);
            this.registeredBedsEffectiveDate = this.facility.registeredBedsList[0].startDate;
        }
        else if (this.facility) {
            this.registeredBeds = 0;
            this.registeredBedsEffectiveDate = null;
        }
        else {
            this.registeredBeds = null;
            this.registeredBedsEffectiveDate = null;
        }
    }
    resetSupportedResidentsThreshold() {
        if (this.facility && this.facility.supportedResidentsThresholdList && this.facility.supportedResidentsThresholdList.length > 0) {
            this.supportedResidentsThreshold = Number.parseFloat(this.facility.supportedResidentsThresholdList[0].value);
            this.supportedResidentsThresholdEffectiveDate = this.facility.supportedResidentsThresholdList[0].startDate;
        }
        else if (this.facility) {
            this.supportedResidentsThreshold = 0;
            this.supportedResidentsThresholdEffectiveDate = null;
        }
        else {
            this.supportedResidentsThreshold = null;
            this.supportedResidentsThresholdEffectiveDate = null;
        }
    }
    resetNumberOfUnits() {
        if (this.facility && this.facility.numberOfUnitsList && this.facility.numberOfUnitsList.length > 0) {
            this.numberOfUnits = Number.parseInt(this.facility.numberOfUnitsList[0].value);
            this.numberOfUnitsEffectiveDate = this.facility.numberOfUnitsList[0].startDate;
        }
        else if (this.facility) {
            this.numberOfUnits = 0;
            this.numberOfUnitsEffectiveDate = null;
        }
        else {
            this.numberOfUnits = null;
            this.numberOfUnitsEffectiveDate = null;
        }
    }
}
exports.FacilityDetailsEditTabComponent = FacilityDetailsEditTabComponent;
FacilityDetailsEditTabComponent.ɵfac = function FacilityDetailsEditTabComponent_Factory(t) { return new (t || FacilityDetailsEditTabComponent)(i0.ɵɵdirectiveInject(i1.FacilityService), i0.ɵɵdirectiveInject(i2.FundingService), i0.ɵɵdirectiveInject(i3.DnaRSnackBarService), i0.ɵɵdirectiveInject(i4.MatDialog)); };
FacilityDetailsEditTabComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FacilityDetailsEditTabComponent, selectors: [["facility-details-edit-tab"]], inputs: { facility: "facility" }, outputs: { onDone: "onDone" }, decls: 88, vars: 14, consts: [[1, "facility-details-tab", "vertical-tab"], ["unsaved-changes-warning", "", "novalidate", "", "name", "saveFacilityForm", "data-automation", "saveFacilityForm", 1, "form-horizontal", 3, "ngSubmit"], ["saveFacilityForm", "ngForm"], [1, "panel-body"], [1, "form-section"], [1, "row", "space-below-label"], [1, "col-xs-5"], [1, "required-field"], ["for", "agedCareServiceName", 4, "ngIf"], [1, "col-xs-4"], ["id", "agedCareServiceName", "name", "agedCareServiceName", "data-automation", "agedCareServiceName", "type", "text", "required", "", "maxlength", "255", 1, "form-control", 3, "ngModel", "ngModelChange"], ["agedCareServiceName", "ngModel"], [4, "ngIf"], [1, "row"], [1, "sub-header-locations"], [1, "optional"], [1, "col-xs-6"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], ["id", "newLocation", "placeholder", "New location", 1, "form-control", 3, "matChipInputFor", "matChipInputSeparatorKeyCodes", "matChipInputTokenEnd"], [1, "sub-header"], [1, "street1"], ["for", "street1"], ["id", "street1", "name", "street1", "data-automation", "street1", "maxlength", "50", "type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "street2"], ["id", "street2", "name", "street2", "data-automation", "street2", "maxlength", "50", "type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "suburb"], ["id", "suburb", "name", "suburb", "data-automation", "suburb", "maxlength", "50", "type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "state"], [1, "col-xs-3"], ["id", "state", "name", "state", "data-automation", "state", 1, "form-control", 3, "ngModel", "ngModelChange"], ["value", ""], ["value", "AustralianCapitalTerritory"], ["value", "NewSouthWales"], ["value", "NorthernTerritory"], ["value", "Queensland"], ["value", "SouthAustralia"], ["value", "Tasmania"], ["value", "Victoria"], ["value", "WesternAustralia"], ["for", "postCode"], [1, "col-xs-2"], ["id", "postCode", "ui-mask", "9999", "ui-mask-placeholder", "", "ui-mask-placeholder-char", "space", "ui-options", "{clearOnBlur: false}", "name", "postCode", "data-automation", "postCode", "type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "panel-footer"], [1, "pull-left"], ["data-automation", "cancel-button", 1, "btn", "btn-warning", "btn-lg", "btn-inline-block-lg", 3, "click"], [1, "pull-right"], ["type", "submit", "data-automation", "save-button", 1, "btn", "btn-primary", "btn-lg", "btn-inline-block-lg"], ["for", "agedCareServiceName"], ["class", "text-danger", "data-automation", "agedCareServiceName-rac-error-required", 4, "ngIf"], ["class", "text-danger", "data-automation", "agedCareServiceName-ilu-error-required", 4, "ngIf"], ["data-automation", "agedCareServiceName-rac-error-required", 1, "text-danger"], ["data-automation", "agedCareServiceName-ilu-error-required", 1, "text-danger"], ["for", "napsId"], ["matTooltip", "National Approved Provider System", 1, "dna-info-icon", 3, "matTooltipPosition"], ["id", "napsId", "name", "napsId", "data-automation", "napsId", "type", "text", "required", "", "pattern", "^[0-9]*$", "maxlength", "5", 1, "form-control", 3, "ngModel", "ngModelChange"], ["napsId", "ngModel"], ["for", "ediMinorCustomerID"], ["id", "ediMinorCustomerID", "name", "ediMinorCustomerID", "data-automation", "ediMinorCustomerID", "type", "text", "required", "", "pattern", "^[A-Za-z]{3}[0-9]{5}$", "maxlength", "255", 1, "form-control", 3, "ngModel", "ngModelChange"], ["ediMinorCustomerID", "ngModel"], ["for", "archId"], ["id", "archId", "name", "archId", "type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["archId", "ngModel"], ["class", "row space-below-label", 4, "ngIf"], ["for", "significantlyRefurbished"], ["type", "date", "id", "significantlyRefurbished", "name", "significantlyRefurbished", "data-automation", "significantlyRefurbished", 1, "form-control", 3, "ngModel", "ngModelChange"], ["for", "facilityMMMClassification"], [1, "dna-info-icon", 3, "dnaRPopover"], ["mmmDefinition", ""], ["id", "facilityMMMClassification", "name", "facilityMMMClassification", "data-automation", "facilityMMMClassification", "required", "", 1, "form-control", 2, "width", "auto", 3, "disabled", "ngModel", "ngModelChange"], ["facilityMMMClassification", "ngModel"], [3, "value", 4, "ngFor", "ngForOf"], [1, "col-xs-offset-5", "col-xs-6"], ["class", "text-x-small", 4, "ngIf"], [1, "col-xs-1", "margin-top-5"], ["href", "javascript:;", 3, "click"], [1, "col-xs-3", "margin-left-20", "margin-top-5"], ["class", "view-value-note", 4, "ngIf"], [1, "col-xs-5", "space-below"], ["class", "text-danger", "data-automation", "napsId-error-required", 4, "ngIf"], ["class", "text-danger", "data-automation", "napsId-error-format", 4, "ngIf"], ["data-automation", "napsId-error-required", 1, "text-danger"], ["data-automation", "napsId-error-format", 1, "text-danger"], ["class", "text-danger", "data-automation", "ediMinorCustomerID-error-required", 4, "ngIf"], ["class", "text-danger", "data-automation", "ediMinorCustomerID-error-format", 4, "ngIf"], ["data-automation", "ediMinorCustomerID-error-required", 1, "text-danger"], ["data-automation", "ediMinorCustomerID-error-format", 1, "text-danger"], ["for", "regionId"], ["ng-options", "region.id as region.name for region in regions", "id", "regionId", "name", "regionId", "data-automation", "regionId", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["regionId", "ngModel"], ["class", "text-danger", "data-automation", "regionId-error-required", 4, "ngIf"], ["data-automation", "regionId-error-required", 1, "text-danger"], [1, "mmm-popover", "popover-inner"], ["ng-bind", "uibTitle", "ng-if", "uibTitle", 1, "popover-title", "ng-binding", "ng-scope"], ["ng-bind", "content", 1, "popover-content", "ng-binding"], [3, "value"], ["class", "text-danger", "data-automation", "facilityMMMClassification-error-required", 4, "ngIf"], ["data-automation", "facilityMMMClassification-error-required", 1, "text-danger"], [1, "text-x-small"], ["href", "https://www.health.gov.au/resources/apps-and-tools/health-workforce-locator/health-workforce-locator"], [1, "view-value-note"], ["for", "careMinutesSupplement"], ["aria-label", "Care minutes supplement information", 1, "dna-info-icon", 3, "dnaRPopover"], ["careMinutesSupplement", ""], [1, "dollar-input-container"], ["id", "careMinutesSupplement", "name", "careMinutesSupplement", "type", "number", "min", "0", "max", "9999999.99", "step", "0.01", 1, "form-control", "no-spinner", 3, "ngModel", "ngModelChange", "keydown"], ["careMinutesSupplement", "ngModel"], [3, "selectable", "removable", "removed"], ["matChipRemove", "", "class", "icon icon-close-fill", 4, "ngIf"], ["matChipRemove", "", 1, "icon", "icon-close-fill"]], template: function FacilityDetailsEditTabComponent_Template(rf, ctx) { if (rf & 1) {
        const _r59 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "form", 1, 2);
        i0.ɵɵlistener("ngSubmit", function FacilityDetailsEditTabComponent_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r59); const _r0 = i0.ɵɵreference(2); return ctx.saveFacility(_r0.valid); });
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelement(7, "i", 7);
        i0.ɵɵtemplate(8, FacilityDetailsEditTabComponent_label_8_Template, 2, 0, "label", 8);
        i0.ɵɵtemplate(9, FacilityDetailsEditTabComponent_label_9_Template, 2, 0, "label", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelementStart(11, "input", 10, 11);
        i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_Template_input_ngModelChange_11_listener($event) { return ctx.facility.agedCareServiceName = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, FacilityDetailsEditTabComponent_div_13_Template, 3, 2, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, FacilityDetailsEditTabComponent_div_14_Template, 79, 23, "div", 12);
        i0.ɵɵtemplate(15, FacilityDetailsEditTabComponent_div_15_Template, 11, 2, "div", 12);
        i0.ɵɵelementStart(16, "div", 13);
        i0.ɵɵelementStart(17, "div", 6);
        i0.ɵɵelementStart(18, "h3", 14);
        i0.ɵɵtext(19, "Locations ");
        i0.ɵɵelementStart(20, "span", 15);
        i0.ɵɵtext(21, "(optional)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 16);
        i0.ɵɵelementStart(23, "mat-chip-list", null, 17);
        i0.ɵɵtemplate(25, FacilityDetailsEditTabComponent_mat_chip_25_Template, 3, 4, "mat-chip", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "input", 19);
        i0.ɵɵlistener("matChipInputTokenEnd", function FacilityDetailsEditTabComponent_Template_input_matChipInputTokenEnd_26_listener($event) { return ctx.addLocations($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 5);
        i0.ɵɵelementStart(28, "div", 6);
        i0.ɵɵelementStart(29, "h3", 20);
        i0.ɵɵtext(30, "Address ");
        i0.ɵɵelementStart(31, "span", 15);
        i0.ɵɵtext(32, "(optional)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 5);
        i0.ɵɵelementStart(34, "div", 21);
        i0.ɵɵelementStart(35, "div", 6);
        i0.ɵɵelementStart(36, "label", 22);
        i0.ɵɵtext(37, "Street line 1");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 6);
        i0.ɵɵelementStart(39, "input", 23);
        i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_Template_input_ngModelChange_39_listener($event) { return ctx.facility.street1 = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "div", 5);
        i0.ɵɵelementStart(41, "div", 6);
        i0.ɵɵelementStart(42, "label", 24);
        i0.ɵɵtext(43, "Street line 2");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "div", 6);
        i0.ɵɵelementStart(45, "input", 25);
        i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_Template_input_ngModelChange_45_listener($event) { return ctx.facility.street2 = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div", 5);
        i0.ɵɵelementStart(47, "div", 6);
        i0.ɵɵelementStart(48, "label", 26);
        i0.ɵɵtext(49, "Suburb or town");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div", 9);
        i0.ɵɵelementStart(51, "input", 27);
        i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_Template_input_ngModelChange_51_listener($event) { return ctx.facility.suburb = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(52, "div", 5);
        i0.ɵɵelementStart(53, "div", 6);
        i0.ɵɵelementStart(54, "label", 28);
        i0.ɵɵtext(55, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(56, "div", 29);
        i0.ɵɵelementStart(57, "select", 30);
        i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_Template_select_ngModelChange_57_listener($event) { return ctx.facility.state = $event; });
        i0.ɵɵelement(58, "option", 31);
        i0.ɵɵelementStart(59, "option", 32);
        i0.ɵɵtext(60, "ACT");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(61, "option", 33);
        i0.ɵɵtext(62, "New South Wales");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(63, "option", 34);
        i0.ɵɵtext(64, "Northern Territory");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(65, "option", 35);
        i0.ɵɵtext(66, "Queensland");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(67, "option", 36);
        i0.ɵɵtext(68, "South Australia");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(69, "option", 37);
        i0.ɵɵtext(70, "Tasmania");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(71, "option", 38);
        i0.ɵɵtext(72, "Victoria");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(73, "option", 39);
        i0.ɵɵtext(74, "Western Australia");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(75, "div", 5);
        i0.ɵɵelementStart(76, "div", 6);
        i0.ɵɵelementStart(77, "label", 40);
        i0.ɵɵtext(78, "Postcode");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(79, "div", 41);
        i0.ɵɵelementStart(80, "input", 42);
        i0.ɵɵlistener("ngModelChange", function FacilityDetailsEditTabComponent_Template_input_ngModelChange_80_listener($event) { return ctx.facility.postCode = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(81, "div", 43);
        i0.ɵɵelementStart(82, "div", 44);
        i0.ɵɵelementStart(83, "a", 45);
        i0.ɵɵlistener("click", function FacilityDetailsEditTabComponent_Template_a_click_83_listener() { return ctx.doneEditting(true); });
        i0.ɵɵtext(84, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(85, "div", 46);
        i0.ɵɵelementStart(86, "button", 47);
        i0.ɵɵtext(87, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(2);
        const _r3 = i0.ɵɵreference(12);
        const _r7 = i0.ɵɵreference(24);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.facility.facilityType === "AgeCare");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.facility.facilityType === "IndependentLiving");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.facility.agedCareServiceName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", _r0.submitted || (_r3 == null ? null : _r3.touched));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.facility.facilityType === "AgeCare");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.facility.facilityType === "IndependentLiving");
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngForOf", ctx.facility.locations);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matChipInputFor", _r7)("matChipInputSeparatorKeyCodes", ctx.separatorKeysCodes);
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("ngModel", ctx.facility.street1);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngModel", ctx.facility.street2);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngModel", ctx.facility.suburb);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngModel", ctx.facility.state);
        i0.ɵɵadvance(23);
        i0.ɵɵproperty("ngModel", ctx.facility.postCode);
    } }, directives: [i5.ɵangular_packages_forms_forms_y, i5.NgControlStatusGroup, i5.NgForm, i6.NgIf, i5.DefaultValueAccessor, i5.RequiredValidator, i5.MaxLengthValidator, i5.NgControlStatus, i5.NgModel, i7.MatChipList, i6.NgForOf, i7.MatChipInput, i5.SelectControlValueAccessor, i5.NgSelectOption, i5.ɵangular_packages_forms_forms_x, i8.MatTooltip, i5.PatternValidator, i9.DnaRPopoverDirective, i5.NumberValueAccessor, i7.MatChip, i10.MatIcon, i7.MatChipRemove], pipes: [i6.DatePipe], styles: [".facility-details-tab[_ngcontent-%COMP%]     .mat-chip-list-wrapper {\n  margin-top: 12px;\n  margin-bottom: 20px;\n}\n.facility-details-tab[_ngcontent-%COMP%]     .mat-chip-list-wrapper .mat-standard-chip {\n  border-radius: 4px;\n}\n.facility-details-tab[_ngcontent-%COMP%]     .icon.icon-info-fill {\n  height: 18px;\n  width: 18px;\n  vertical-align: text-bottom;\n}\n.facility-details-tab[_ngcontent-%COMP%]     label {\n  font-weight: 400;\n}\n.facility-details-tab[_ngcontent-%COMP%]     .dollar-input-container:before {\n  top: 7px;\n  font-size: 14px;\n}\n.popover-inner[_ngcontent-%COMP%] {\n  background: #ffffff;\n  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.3);\n}\n.popover-inner.mmm-popover[_ngcontent-%COMP%] {\n  width: 275px;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FacilityDetailsEditTabComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'facility-details-edit-tab',
                styleUrls: ['./facility-details-edit-tab.component.less'],
                templateUrl: './facility-details-edit-tab.component.html'
            }]
    }], function () { return [{ type: i1.FacilityService }, { type: i2.FundingService }, { type: i3.DnaRSnackBarService }, { type: i4.MatDialog }]; }, { facility: [{
            type: core_1.Input
        }], onDone: [{
            type: core_1.Output
        }] }); })();
